import ApplicationSummary from '@/components/ApplicationSummary';
import { useGetPurchaseApplicationSummaryQuery } from '@/pages/mortgage/apis/purchaseAPI';
import { Typography } from 'antd';
import { useParams } from 'react-router-dom';
const PurchaseApplicationSummary = () => {
  const params = useParams();
  const { data, isLoading } = useGetPurchaseApplicationSummaryQuery({
    application_id: params.id as string,
  });
  return (
    <div>
      <Typography.Title level={3}>
        Purchase Application Summary
      </Typography.Title>
      <ApplicationSummary data={data} isLoading={isLoading} />
    </div>
  );
};

export default PurchaseApplicationSummary;
